module.exports = __webpack_public_path__ + "img/icon-other-room.f1c92804.svg";